import React from 'react';
import NavBar from '../../components/navbar/navBarComponent';
import Breadcrumb from '../../components/breadcrumb/breadcrumbComponent';
import SurveyForm from '../../components/survey-form/surveyForm';

const SurveyCreatePage = (props) => {
  const breadcrumbItems = [
    { name: 'Menu', link: '/menu' },
    { name: 'Surveys', link: '/surveys' },
    { name: 'Create', link: '/surveys-create' },
  ];

  return (
    <div id="main-survey-create" className="container-fluid page">
      <NavBar cart={props.cart} isLogIn={props.isLogIn} />
      <Breadcrumb page="surveys-admin-create" items={breadcrumbItems} />
      <SurveyForm />
    </div>
  );
};

export default SurveyCreatePage;
